import {undef} from './types';
export const defined = (prop) => typeof prop !== undef;
export const getDefinedFallback = (prop, value) => defined(prop) ? prop : value;
